const sectionTitle = (name, t, span = 24, styles = {}, props = {}) => [
  {
    span,
    columns: [
      {
        name: name,
        value: t(name),
        component: 'sectionTitle',
        show: true,
        styles,
        ...props
      }
    ]
  }
];

const field = (
  component,
  name,
  t,
  values,
  otherProps,
  sublabel = false,
  show = true,
  showLabel = true
) => {
  const _label = name.includes('_') ? name.replace('_', '.') : name;
  const val = otherProps ? values[name] || otherProps.defaultValue : values[name];
  const _value = component === 'checkboxGroup' ? {} : { value: val };
  return {
    label: showLabel && _label ? t(`${_label}.label`) : '',
    name: name,
    component,
    sublabel: sublabel ? t(`${name}.sublabel`) : undefined,
    show,
    ..._value,
    ...otherProps
  };
};

const toArrayOfOptions = options =>
  Object.keys(options).map(key => ({
    label: options[key],
    value: key
  }));

const getOptions = (t, name, optionIds) => {
  let options = {};
  optionIds.forEach(opt => (options[opt] = t(`${name}.options.${opt}`)));
  return options;
};

export { sectionTitle, field, toArrayOfOptions, getOptions };
